import { Route } from '@angular/router';
import { CampaignEditComponent } from 'src/app/pages/campaigns/bookings/campaign-edit/campaign-edit.component';
import { CampaignsListComponent } from 'src/app/pages/campaigns/bookings/campaigns-list/campaigns-list.component';
import { RouteGuardService } from 'src/app/services/route-guard.service';
import { commercials } from './commercials';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { FilterStorageService } from '../../../../../services/filter-storage.service';

export const management: Route = {
  path: 'management',
  providers: [FilterStorageService],
  title: 'nav.campaigns.management',
  data: {
    icon: SbIcons.management,
    breadcrumb: 'nav.campaigns.management',
    id: RoutingID.campaigns,
  },
  children: [
    {
      path: '',
      component: CampaignsListComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'campaign-edit/:campaignID',
      data: {
        breadcrumb: 'nav.campaigns.edit',
        icon: SbIcons.edit,
        id: RoutingID.campaignEdit,
      },
      children: [
        {
          path: '',
          canDeactivate: [RouteGuardService],
          component: CampaignEditComponent,
          title: 'nav.campaigns.edit',
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'campaign-create',
      data: {
        breadcrumb: 'nav.campaigns.create',
        icon: SbIcons.plus,
        id: RoutingID.campaignCreate,
      },
      children: [
        {
          title: 'nav.campaigns.create',
          path: '',
          canDeactivate: [RouteGuardService],
          component: CampaignEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    commercials,
  ],
};
